/* eslint-disable complexity */
/* eslint-disable no-console */
/* eslint-disable no-extra-parens */
/* eslint-disable no-inline-comments */
/* eslint-disable semi */

class DataMapper {

  setData(form) {
    this.form = form
  }

  mappedData() {
    return {
      wpf_form: {
        transaction_type: this.transactionType,
        ...(this.paymentToken && { payment_token: this.paymentToken }),
        ...(this.shippingAddressCheckbox &&
          { shipping_address_checkbox: this.shippingAddressCheckbox }),
        ...this.customerInfo,
        ...this.creditCard,
        ...this.apm,
        ...this.addresses,
        ...this.accountOwnerAttributes,
        ...this.termsAndConditions
      },
      ...(this.tokenId &&
        { token_id: this.tokenId }),
      ...this.browserAttributes
    }
  }

  get paymentToken() {
    return this.form.payment_token
  }

  get transactionType() {
    return this.form.paymentMethod.selected
  }

  get customerInfo() {
    const customerInfo = this.form.customerInfo

    return {
      ...(customerInfo.birthCity && { birth_city: customerInfo.birthCity }),
      ...(customerInfo.birthDate && { birth_date: customerInfo.birthDate }),
      ...(customerInfo.birthState && { birth_state: customerInfo.birthState }),
      ...(customerInfo.companyActivity && { company_activity: customerInfo.companyActivity }),
      ...(customerInfo.companyType && { company_type: customerInfo.companyType }),
      ...(customerInfo.countryOfOrigin && { country_of_origin: customerInfo.countryOfOrigin }),
      ...(customerInfo.email && { customer_email: customerInfo.email }),
      ...(customerInfo.gender && { gender: customerInfo.gender }),
      ...(customerInfo.incorporationDate &&
        { incorporation_date: customerInfo.incorporationDate }),
      ...(customerInfo.maritalStatus && { marital_status: customerInfo.maritalStatus }),
      ...(customerInfo.mothersName && { mothers_name: customerInfo.mothersName }),
      ...(customerInfo.nationality && { nationality: customerInfo.nationality }),
      ...(customerInfo.phone && { customer_phone: customerInfo.phone }),
      ...(customerInfo.senderOccupation && { sender_occupation: customerInfo.senderOccupation }),
      ...(customerInfo.usage && { usage: customerInfo.usage })
    }
  }

  get addresses() {
    return {
      ...this.billingAddress,
      ...this.shippingAddress
    }
  }

  get accountOwnerAttributes() {
    const accountOwnerAttributes = this.form.accountOwner
    const account_owner = {
      first_name: accountOwnerAttributes.firstName,
      middle_name: accountOwnerAttributes.middleName,
      last_name: accountOwnerAttributes.lastName
    }

    return {
      account_owner
    }
  }

  get shippingAddress() {
    const { shippingAddress } = this.form

    return {
      ...(shippingAddress.firstName && { shipping_address_first_name: shippingAddress.firstName }),
      ...(shippingAddress.lastName && { shipping_address_last_name: shippingAddress.lastName }),
      ...(shippingAddress.address1 && { shipping_address_address1: shippingAddress.address1 }),
      ...(shippingAddress.address2 && { shipping_address_address2: shippingAddress.address2 }),
      ...(shippingAddress.city && { shipping_address_city: shippingAddress.city }),
      ...(shippingAddress.neighborhood &&
        { shipping_address_neighborhood: shippingAddress.neighborhood }),
      ...(shippingAddress.country && { shipping_address_country: shippingAddress.country }),
      ...(shippingAddress.state && { shipping_address_state: shippingAddress.state }),
      ...(shippingAddress.zipCode && { shipping_address_zip_code: shippingAddress.zipCode })
    }
  }

  get billingAddress() {
    const { billingAddress } = this.form

    return {
      ...(billingAddress.firstName && { billing_address_first_name: billingAddress.firstName }),
      ...(billingAddress.lastName && { billing_address_last_name: billingAddress.lastName }),
      ...(billingAddress.address1 && { billing_address_address1: billingAddress.address1 }),
      ...(billingAddress.address2 && { billing_address_address2: billingAddress.address2 }),
      ...(billingAddress.city && { billing_address_city: billingAddress.city }),
      ...(billingAddress.neighborhood &&
        { billing_address_neighborhood: billingAddress.neighborhood }),
      ...(billingAddress.country && { billing_address_country: billingAddress.country }),
      ...(billingAddress.state && { billing_address_state: billingAddress.state }),
      ...(billingAddress.zipCode && { billing_address_zip_code: billingAddress.zipCode })
    }
  }

  get apm() {
    return {
      ...(this.voucherNumber && { voucher_number: this.voucherNumber }),
      ...(this.iban && { iban: this.iban }),
      ...(this.bic && { bic: this.bic }),
      ...(this.userId && { user_id: this.userId }),
      ...(this.bankCode && { bank_code: this.bankCode }),
      ...(this.bankAccountNumber && { bank_account_number: this.bankAccountNumber }),
      ...this.birthDate,
      ...(this.documentId && { document_id: this.documentId }),
      ...(this.nationalId && { national_id: this.nationalId }),
      ...(this.consumerReference && { consumer_reference: this.consumerReference }),
      ...(this.authCode && { auth_code: this.authCode }),
      ...(this.documentIdLabel && { document_id_label: this.documentIdLabel }),
      ...this.ezeewallet,
      ...(this.paymentType && { payment_type: this.paymentType })
    }
  }

  get voucherNumber() {
    return this.form.paymentMethod.attributes.voucherNumber
  }

  get iban() {
    return this.form.paymentMethod.attributes.iban
  }

  get bic() {
    return this.form.paymentMethod.attributes.bic
  }

  get userId() {
    return this.form.paymentMethod.attributes.userId
  }

  get bankCode() {
    return this.form.paymentMethod.attributes.bankCode
  }

  get bankAccountNumber() {
    return this.form.paymentMethod.attributes.bankAccount
  }

  get shippingAddressCheckbox() {
    return this.form.shippingAddressCheckbox ? '1' : false
  }

  get documentId() {
    return this.form.paymentMethod.attributes.documentId
  }

  get nationalId() {
    return this.form.paymentMethod.attributes.nationalId
  }

  get consumerReference() {
    return this.form.paymentMethod.attributes.consumerReference
  }

  get paymentType() {
    return this.form.paymentMethod.attributes.paymentType
  }

  get authCode() {
    return this.form.paymentMethod.attributes.authCode
  }

  get documentIdLabel() {
    return this.form.paymentMethod.attributes.documentIdLabel
  }

  get ezeewallet() {
    const { sourceWalletId, sourceWalletPwd, merchant_website } = this.form.paymentMethod.attributes

    return {
      ...(sourceWalletId && { source_wallet_id: sourceWalletId }),
      ...(sourceWalletPwd && { source_wallet_pwd: sourceWalletPwd }),
      ...(merchant_website && { merchant_website: merchant_website })
    }
  }

  get birthDate() {
    const { birthDate } = this.form.paymentMethod.attributes
    const date  = {
      day: birthDate?.day?.toString(),
      month: birthDate?.month?.toString(),
      year: birthDate?.year?.toString()
    }

    return {
      ...(date.day && { 'birth_date(3i)': date.day }),
      ...(date.month && { 'birth_date(2i)': date.month }),
      ...(date.year && { 'birth_date(1i)': date.year })
    }
  }

  get creditCard() {
    const { saveCard, cardHolder, cardNumber, cvv,
      cardExpiryDate, birthDate } = this.form.paymentMethod.attributes

    return {
      ...(!this.tokenId && {
        ...(saveCard && { remember_card: saveCard ? '1' : '0' }),
        ...(cardHolder && { card_holder: cardHolder }),
        ...(cardNumber && { card_number: cardNumber }),
        ...(cardExpiryDate &&
          { 'expiration_date(2i)': this.expiryDate.month }),
        ...(cardExpiryDate &&
          { 'expiration_date(1i)': this.expiryDate.year }),
        ...(birthDate && this.birthDate)
      }),
      ...(cvv && { cvv: cvv })
    }
  }

  get expiryDate() {
    const date = this.form.paymentMethod.attributes.cardExpiryDate?.split('/') || []
    const month = date[0] || ''
    const year = date[0] && date[1]
      ? new Date(`${date[0]}/01/${date[1]}`).getFullYear().toString() : ''

    return { month, year }
  }

  get termsAndConditions() {
    return {
      ...(typeof this.form.terms !== 'undefined' && {
        tac: this.form.terms ? '1' : '0'
      }),
      ...(typeof this.form.terms === 'undefined' && {
        tac: '0'
      })
    }
  }

  get tokenId() {
    return this.form.paymentMethod.attributes.tokenId
  }

  get browserAttributes() {
    const { browser } = this.form

    return {
      browser_java_enabled: browser.javaEnabled ? '1' : '0',
      browser_language: browser.language,
      browser_color_depth: browser.colorDepth?.toString(),
      browser_screen_height: browser.screenHeight?.toString(),
      browser_screen_width: browser.screenWidth?.toString(),
      browser_time_zone_offset: browser.timezoneOffset?.toString()
    }
  }

}

export default DataMapper
